var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavouriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4454 28.7608L11.5762 20.5663C9.35964 18.2582 9.49922 14.4736 11.8792 12.3493C14.2403 10.2418 17.8204 10.6511 19.6863 13.2417L20 13.6772L20.3137 13.2417C22.1796 10.6511 25.7596 10.2418 28.1208 12.3493C30.5008 14.4736 30.6404 18.2582 28.4238 20.5663L20.5546 28.7608C20.2483 29.0797 19.7517 29.0797 19.4454 28.7608Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteIcon);
export default __webpack_public_path__ + "static/media/favouriteIcon.7bacd5bc5995054a3c221bd74be98a39.svg";
export { ForwardRef as ReactComponent };